// src/components/AdminNavbar.js
import { Link } from "react-router-dom";
import { auth } from "../lib/firebase";
import { signOut } from "firebase/auth";

const AdminNavbar = () => {
  const logout = async () => {
    try {
      await signOut(auth);
      // Use window.location for navigation outside Router context
      window.location.href = "/admin-login";
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <div className="bg-black text-white px-6 py-3 flex justify-between">
      <div className="flex gap-4">
        {/* FIXED: Updated to match your nested route structure */}
        <Link to="/admin">Dashboard</Link>
        <Link to="/admin/team">Team</Link>
      </div>
      <button onClick={logout} className="text-red-400 hover:text-red-300">
        Logout
      </button>
    </div>
  );
};

export default AdminNavbar;